import React from 'react';
import pt from 'prop-types';
import withWidget from './with-widget';
import { WidgetContext } from 'client/src/components/storefront/editor/widgets';
import Link from 'components/link';
import Icon from 'components/icon';

function SwellHeader({ field }) {
  const { page, pageRecord } = React.useContext(WidgetContext);

  switch (field.params?.content_type) {
    case 'info':
      // information message
      return <span className="form-field-hint">{field.label}</span>;
    case 'link': {
      // link to the page collection
      return (
        <span className="form-field-hint">
          {field.label}
          <Link
            className="storefront-editor--sub-header--open-record"
            to={`/${page.collection}/${pageRecord.id}`}
            target="blank"
          >
            <Icon fa="arrow-up-right-from-square" />
          </Link>
        </span>
      );
    }
    default:
      // header
      return (
        <h5 className="storefront-editor-widget--header">{field.label}</h5>
      );
  }
}

SwellHeader.propTypes = {
  field: pt.object,
};

export default withWidget(SwellHeader);
